import React, { type ForwardedRef } from 'react';
import RawHtml from 'utils/miscUtils/rawHtml';
import useTimeAgo from 'hooks/useTimeAgo';
import Link from 'components/Globals/Base/Link';
import { LATEST_NEWS_TEST_IDS } from 'constants/testsIds/homepage';
import * as S from './HomeLatestStyles';

export interface HomeLatestProps {
  title: string;
  titleLink: string;
  section: string;
  date: string;
  className?: string;
}

const HomeLatest = (
  { title, titleLink, section, date, className }: HomeLatestProps,
  ref?: ForwardedRef<HTMLLIElement> | null,
) => {
  const timeAgo = useTimeAgo(date);

  const trackingData = {
    contentPlacementCD: section,
    eventAction: 'latest',
    eventCategory: 'article',
    eventLabel: `title click : ${title}`,
  };

  return (
    <S.Wrapper
      ref={ref}
      className={className}
    >
      <S.Card data-cy={LATEST_NEWS_TEST_IDS.ARTICLE}>
        <Link
          href={titleLink}
          className='title-link'
          trackingData={trackingData}
          type='primary'
          dataCy={LATEST_NEWS_TEST_IDS.LINK}
        >
          {RawHtml({ html: title })}
        </Link>
        <br />
        {date ? <S.TimeAgo data-cy={LATEST_NEWS_TEST_IDS.DATE}>{timeAgo}</S.TimeAgo> : <br />}
      </S.Card>
    </S.Wrapper>
  );
};

export default React.forwardRef(HomeLatest);
